import React, { Component } from 'react';
import { APP_URL_API } from '../../../setup/configs';
import axios from 'axios';
import Header from '../../common/Header';
import AuthService from '../../auth/AuthService';
import withAuth from '../../auth/withAuth';
var fileDownload = require('js-file-download');

/*

Settings is wrapped in a HoC (Higher order component). This component takes care of checking if user is
logged in and retrieves the user type. If user is not logged in, he/she is sent to the login form.

Settings is an interface for unlocking years and downloading excel files

Its important to mention that the first year on the list is 2018 and that it is deactivated by default. When you activate the
year, next year will appear on the next line.

*/

class Settings extends Component {
	constructor(props) {
        super(props);
        this.state = {
            years: [],
            dataLoaded: false
        }
	}

	componentDidMount = () => {
		this.getYears();
	}

	getYears = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'years';

        this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                    if(result.data.data.length>0){
	                    this.setState({
	                        years: result.data.data,
	                        dataLoaded: true
	                    });
                    } else {
                    	this.setState({
	                        dataLoaded: true
	                    });
                    }
                }.bind(this))
	}

	onHandleOpenYear = (year) => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'years';

        const data = {};
        data.year = year;

        this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                    this.getYears();
                }.bind(this))
	}

	onHandleDownloadMissingAnnualReports = (year) => {
		this.onHandleDownloadFile(year, 'export/missingAnnualReports/excel', 'Manglende_årsregnskaber_og_donationer_'+year);
	}

	onHandleDownloadMemberCount = (year) => {
		this.onHandleDownloadFile(year, 'export/memberships/excel', 'Medlemstal_'+year);
	}

	onHandleDownloadDonations = (year) => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token };
        const URL = APP_URL_API + 'export/donations/excel/year/' + year;

        this.serverRequest =
            axios
                .get(URL, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                	fileDownload(response.data, 'donationer.xlsx');
                }.bind(this))
	}

	onHandleDownloadCompleteList = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token };
        const URL = APP_URL_API + 'export/organizations/excel';

        this.serverRequest =
            axios
                .get(URL, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                	console.log(response);
                	fileDownload(response.data, 'liste_over_anerkendte_trossamfund.xlsx');
                }.bind(this))
	}
	
	onHandleDownloadDonationsList = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token };
        const URL = APP_URL_API + 'export/donationsTotal/excel';

        this.serverRequest =
            axios
                .get(URL, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                	console.log(response);
                	fileDownload(response.data, 'liste_over_samlede_donationsbeloeb.xlsx');
                }.bind(this))
	}

	onHandleDownloadFile = (year, url, filename) => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const URL = APP_URL_API + url;

        let data = {};
        data.year = year;

        this.serverRequest =
            axios
                .post(URL, data, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                	fileDownload(response.data, filename+'.xlsx');
                }.bind(this))
	}

	render() {
		return (
			<div>
				<Header user={this.props.user} history={this.props.history}>
	              {this.props.user.type === 'admin' && <nav className="navigation">
	                <ul className="navigation__list">
	                  <li className="navigation__listitem"><a href="/admin/organizations/">Oversigt</a></li>
	                  <li className="navigation__listitem"><a href="/admin/organization/create">Opret</a></li>
	                  <li className="navigation__listitem active"><a href="/admin/organizations/settings">Indstillinger</a></li>
	                </ul>
	              </nav>}
	            </Header>

	            <ul className="navigation__list navigation__list--settings">
	            	<li className="navigation__listitem--small"><u>Årsoversigt</u></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert/">Tilsynsmeddelelse</a></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert-info/">Informationsmeddelelse</a></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/mail/">Mailafsendelse</a></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/administrators/">Brugerstyring</a></li>
            	</ul>

	            <div className="content-wrapper">
	                    <div style={{margin: '2em 0'}}>
		                    <h3 className="list-header">Årsoversigt</h3>
		                    <p>På denne side er det muligt at give adgang til indberetning af årsregnskaber, oplysninger om donationer og medlemstal for anerkendte trossamfund og menigheder, der er omfattet af et trossamfunds anerkendelse, for de enkelte år. Anerkendte trossamfund og menigheder, der er omfattet af et trossamfund anerkendelse, kan indberette oplysninger for åbne år. Når et trossamfund eller en menighed har foretaget indberetning, låses de indberettede oplysninger, og det vil herefter kun være muligt for By-, Land- og Kirkeministeriet at foretage ændringer heri, hvis trossamfundet eller menigheden anmoder herom.
							<br/>Indberettede årsregnskaber og oplysninger om donationer vises direkte på hjemmesiden.</p>
		                    <p>På denne side er det også muligt at hente excel-ark med oplysninger om:</p>
		                    <ul>
		                    	<li>Alle anerkendte trossamfund og menigheder, der omfattet af et trossamfunds anerkendelse, der mangler at indberette årsregnskaber og oplysninger om donationer.</li>
		                    	<li>Indberettede medlemstal for anerkendte trossamfund og menigheder, der er omfattet af et trossamfunds anerkendelse.</li>
		                    	<li>En fuldstændig liste over gældende oplysninger om nuværende anerkendte trossamfund og menigheder omfattet af et trossamfunds anerkendelse, der er indberettet til Trossamfundsregistret i henhold til kapitel 3 samt § 20 og § 21, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken.</li>
		                    </ul>
	                    </div>
	                    <div style={{margin: '2em 0'}}>
	                    	{this.state.dataLoaded &&
	                    		<List years={this.state.years}
	                    			onHandleOpenYear={this.onHandleOpenYear}
	                    			onHandleDownloadMissingAnnualReports={this.onHandleDownloadMissingAnnualReports}
									onHandleDownloadDonations={this.onHandleDownloadDonations}
	                    			onHandleDownloadMemberCount={this.onHandleDownloadMemberCount} />}
	                    </div>
	                    <div style={{margin: '2em 0'}}>
	                    	<Actions onHandleDownloadCompleteList={this.onHandleDownloadCompleteList} onHandleDownloadDonationsList={this.onHandleDownloadDonationsList} />
	                    </div>
	            </div>
	        </div>
		)
	}
}

export default withAuth(Settings);

const Actions = (props) => {
	return (
		<div>
			<p><button onClick={props.onHandleDownloadCompleteList} className="button ocean">Fuld liste over alle anerkendte trossamfund og menigheder d.d.</button></p>
			<p><button onClick={props.onHandleDownloadDonationsList} className="button ocean">Oversigt over samlede donationsbeløb</button></p>
		</div>
		)
}

const ListHead = () => {
	return (
		<thead>
			<tr>
				<th></th>
				<th style={{textAlign: 'left'}}>Ikke aktivt</th>
				<th style={{textAlign: 'left'}}>Åbent</th>
				<th style={{textAlign: 'left'}}>Manglende årsregnskaber og donationer</th>
				<th style={{textAlign: 'left'}}>Donationer</th>
				<th style={{textAlign: 'left'}}>Medlemstal</th>
			</tr>
		</thead>
		)
}

const List = (props) => {
	let list = [];
	let lastOpenYear = '2017';
	let nextYear;

	if(props.years.length>0) {
		props.years.forEach(function(year) {
			list.push(<ListRow year={year.year} key={year.year} open={true} onHandleDownloadDonations={props.onHandleDownloadDonations} onHandleDownloadMissingAnnualReports={props.onHandleDownloadMissingAnnualReports} onHandleDownloadMemberCount={props.onHandleDownloadMemberCount} />);
			lastOpenYear = year.year;
		})
	}
	nextYear = parseInt(lastOpenYear) + 1;
	list.push(<ListRow year={nextYear} key={nextYear} open={false} onHandleOpenYear={props.onHandleOpenYear} />);
	const inversedList = list.reverse();
	return (
			<table style={{width: '100%'}}>
				<ListHead />
				<tbody>{inversedList}</tbody>
			</table>
		);
}

const ListRow = (props) => {
	return (
		<tr>
			<td>{props.year.toString()}</td>
			<td><input type="radio" name={props.year.toString()} defaultChecked={props.open ? false : true} disabled={props.open ? 'disabled' : ''} /></td>
			<td><input type="radio" name={props.year.toString()} defaultChecked={props.open ? true : false} onChange={() => { if (window.confirm('Er du sikker på at du vil åbne for år ' + props.year)) props.onHandleOpenYear(props.year) }} /></td>
			<td>{props.open ? <button onClick={() => props.onHandleDownloadMissingAnnualReports(props.year)}>Hent</button> : ''}</td>
			<td>{props.open && props.year >= "2022" ? <button onClick={() => props.onHandleDownloadDonations(props.year)}>Hent</button> : ''}</td>
			<td>{props.open ? <button onClick={() => props.onHandleDownloadMemberCount(props.year)}>Hent</button> : ''}</td>
		</tr>
		)
}


// WEBPACK FOOTER //
// ./src/modules/admin/organization/Settings.js